import ptBR from "vanillajs-datepicker/locales/pt-BR";
import {Datepicker, DateRangePicker} from "vanillajs-datepicker";
import {v4} from "uuid";

class DatePickerRangeClass{
	/**
	 * 
	 * @param parentObject : jQuery
	 */
	constructor({parentObject}) {
		this.ParentObject = parentObject;
	}

	/**
	 * @returns DatePickerRangeClass
	 */
	load(){
		let currentId = v4();
		let {
			bshName : name,
			bshDatePickerRangeFromDateInputName : fromDateName,
			bshDatePickerRangeToDateInputName : toDateName,
			bshDatePickerRangeToLabelText : toLabelText,
			bshDatePickerRangeMinDate : minDate,
			bshDatePickerRangeAllowOneSidedRange : allowOneSidedRange,
		} = this.ParentObject.data();
		
		this.ObjectId = this.ParentObject.attr("id") ?? name;
	
		this.IdentifierId = !this.ObjectId ? currentId : `${this.ObjectId}_${currentId}`; 
		this.FromDateName = fromDateName ?? "fromInput";
		this.ToDateName = toDateName ?? "toInput";
		this.ToLabelText = toLabelText ?? "Até";
		this.ParsedFromDateId = `${this.IdentifierId}_from_${this.FromDateName}`; 
		this.ParsedToDateId = `${this.IdentifierId}_to_${this.ToDateName}`; 
		this.PanelId = `pnl_${this.IdentifierId}`; 
		this.ParsedObject = 
		$(`<div id="${this.ObjectId}" class="input-group">
				<input class="form-control" name="FromDateName" id="${this.ParsedFromDateId}">
				<span class="input-group-text">${this.ToLabelText}</span>
				<input class="form-control" name="ToDateName" id="${this.ParsedToDateId}">
			</div>			
		`);

		for (let replicableAttribute of this.ParentObject[0].attributes) {
			if (replicableAttribute.name.startsWith("data-bsh-replicate-")) {
				this.ParsedObject.attr(replicableAttribute.name.replace('data-bsh-replicate-', ''), this.ParentObject.attr(replicableAttribute.name));
			}
		}
		Object.assign(Datepicker.locales, ptBR);

		let result = new DateRangePicker(this.ParsedObject[0], {
			language: 'pt-BR',
			buttonClass : 'btn btn-dark',
			minDate: minDate,
			todayButton: true,
			todayButtonMode: 1,
			clearButton: true,
			allowOneSidedRange : allowOneSidedRange ?? true
		});
		
		this.ParentObject.replaceWith(this.ParsedObject);
		this.DateRangePicker = result;
		return this;
	}
}

class DatePickerHelperClass{
	constructor() {
		if (window.DatePickerHelperClass) {
			return window.DatePickerHelperClass;
		}
		window.DatePickerHelperClass = this;
	}

	setDatePicker(inputControl) {
		let data = inputControl.data();
		Object.assign(Datepicker.locales, ptBR);

		return new Datepicker(inputControl[0], {
			language: 'pt-BR',
			buttonClass : 'btn btn-dark',
			minDate: (!data["datepickerNoMinDate"]) ? (data["datepickerMinDate"] ?? new Date()) : null,
			maxDate: (!data["datepickerNoMaxDate"]) ? (data["datepickerMaxDate"] ?? new Date()) : null,
			todayButton: true,
			todayButtonMode: 1,
			clearButton: true,
		});
	}

	/**
	 * @returns DatePickerRangeClass
	 */
	setDatePickerRange(blockControl) {
		let datepickerRange = $(blockControl);
		let datepickerRangeObject = new DatePickerRangeClass({
			parentObject: datepickerRange
		});

		return datepickerRangeObject.load();		
	}
}
export const DatePickerHelper = new DatePickerHelperClass();
export {DatePickerRangeClass};